import momentTz from "moment-timezone";
import { Not_Available, Date_Short } from "./FormatConstants.js";
function getDateWithTimezone(dateString, timeZone) {
  return momentTz(dateString).tz(timeZone);
}
function formatDate(dateString, formatString, timeZone) {
  if (isNullOrEmpty(dateString)) {
    return Not_Available;
  }
  if (isNullOrEmpty(formatString)) {
    formatString = Date_Short;
  }
  return getDateWithTimezone(dateString, timeZone).format(formatString);
}
function formatedCreatedBy(createdBy) {
  return createdBy === "NETWORK SERVICE" ? "[service]" : "(" + createdBy + ")";
}
function isNullOrEmpty(value) {
  return typeof value === "undefined" || value === null || value.length === 0;
}
function replaceCRLF(str, replacement) {
  if (!str) {
    return "";
  }
  return str.replace(/\\r?\\n/g, replacement);
}
export {
  formatDate,
  formatedCreatedBy,
  getDateWithTimezone,
  replaceCRLF
};
//# sourceMappingURL=FormatUtils.js.map
